
import { VWebrtc3Push2WowzaLib } from "/vodalys/vwebrtc3_common/services/VWebrtc3Push2WowzaLib.esm.js";

export const testHttp = async (url, port) => {
    try {
        if (!url) throw new Error('Need url');
        if (!port) throw new Error('Need port');
        url = url + ':' + port;
        await fetch(url, { method: "GET", mode: 'no-cors' });
        return true;
    } catch (e) {
        if (e.message.includes('ERR_SSL_PROTOCOL_ERROR')) {
            return true;
        }
        return false;
    }
}

export const testWebsocket = async (url, path = '/socket.io/') => {
    return new Promise((resolve, reject) => {
        socket = io.connect(url, {
            path: path,
            multiplex: false,
            withCredentials: true,
        });

        socket.on("connect", function () {
            resolve(true);
        });

        setTimeout(() => {
            if (!socket.connected) {
                resolve(false); // Connexion échouée après timeout
            }
            socket.disconnect(); // Déconnecte après le test
        }, 5000);
    });
}

let queue = [];
let running = false;

export const testWebRTC = async (wowzaConfig) => {
    return new Promise((resolve, reject) => {
        queue.push({ wowzaConfig, resolve, reject });
        _testWebRTC();
    });
}

export const _testWebRTC = async () => {

    if (running || queue.length === 0) return;

    running = true;
    const { wowzaConfig, resolve, reject } = queue.shift();

    var _resolve = async function (resolved) {
        await webrtcpush.destroy();
        running = false;
        resolve(resolved);
        setTimeout(()=>{_testWebRTC()}, 2000);
    }

    let webrtcpush, timeout;
    let tries = 1;    
    const canvas = document.createElement('canvas');
    const stream = await canvas.captureStream(30);

    try {
        webrtcpush = new VWebrtc3Push2WowzaLib(wowzaConfig, stream, {}, true);
    }
    catch (e) {
        console.error(e);
        return await _resolve(false);
    }

    webrtcpush.on('connect', async () => {
        console.log('connecté au webrtc')
        if (timeout) clearTimeout(timeout);
        return await _resolve(true);
    })

    webrtcpush.on('error', async (e) => {
        console.error('// tries=', tries, ' // ', e);
        if (tries >= 10) {
            return await _resolve(false);
        }
        timeout = setTimeout(() => {

            tries++;
            webrtcpush._connect();
        }, 10000);
    })
}